module.exports = __webpack_public_path__ + "img/pardos.b9158dec.jpg";